module.exports = __webpack_public_path__ + "static/media/IUP_L3.93bf0fb2.svg";